import React, { useState, useEffect } from 'react';
import toast from 'react-hot-toast';
import { addDividendV1 } from '../../composables/fetchAPI'; // นำเข้าฟังก์ชัน dividend ที่เพิ่มไว้
import { usePortfolio } from '../../context/PortfolioContext';

interface EditDividendModalProps {
  isOpen: boolean;
  onClose: () => void;
  portfolioId: string;
  stock: any;
  onSave: () => void;
  subPortfolioId?: string; // เพิ่ม prop สำหรับ subPortId
}

const EditDividendModal: React.FC<EditDividendModalProps> = ({ isOpen, onClose, portfolioId, stock, onSave, subPortfolioId }) => {
  const [newDividend, setNewDividend] = useState<string>('');
  const [isLoading, setIsLoading] = useState(false);
  const { displayMode } = usePortfolio();

 useEffect(() => {
  if (stock && isOpen) {
    // ลำดับความสำคัญ: ลองเช็คทุกฟิลด์ที่อาจเก็บค่าปันผลได้
    const dividendValue = stock.settledDividendNet ?? stock.manualDividend ?? stock.profitIncome ?? 0;
    setNewDividend(String(dividendValue));
  }
}, [stock, isOpen]);

  if (!isOpen || !stock) return null;

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (isNaN(Number(newDividend))) {
      toast.error('กรุณากรอกตัวเลขให้ถูกต้อง');
      return;
    }

    setIsLoading(true);
    try {
      const stockSymbol = stock.stockSymbol || stock.symbol;
      const subPortId = subPortfolioId || stock.subPortId;

      // ส่งค่าไปยัง API (ใช้ action: 'overwrite' เพื่อเปลี่ยนค่าใหม่ตามที่คุณกรอก)
      await addDividendV1(portfolioId, subPortId, stockSymbol, {
        dividend: Number(newDividend),
        action: 'overwrite' 
      });

      toast.success('แก้ไขเงินปันผลสำเร็จ');
      onSave();
      onClose();
    } catch (error: any) {
      console.error(error);
      toast.error(error.message || 'เกิดข้อผิดพลาดในการบันทึก');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 z-[200] flex items-center justify-center p-4">
      <div className="absolute inset-0 bg-black/60 backdrop-blur-sm" onClick={onClose}></div>
      <div className="relative w-full max-w-sm bg-[#18181b] border border-gray-700 rounded-xl shadow-2xl flex flex-col animate-fadeIn">
        <div className="flex justify-between items-center px-5 py-4 border-b border-gray-700">
          <h2 className="text-lg font-bold text-blue-400">แก้ไขเงินปันผล (Dividend)</h2>
          <button onClick={onClose} className="text-gray-400 hover:text-white text-xl">&times;</button>
        </div>

        <form onSubmit={handleSubmit} className="p-5 flex flex-col gap-4">
          <div className="bg-gray-800 p-3 rounded-lg border border-gray-700 text-sm">
            <div className="text-gray-400 mb-1">หุ้น: <span className="text-white font-bold">{stock.stockSymbol || stock.symbol}</span></div>
            <div className="text-gray-400">ปันผลปัจจุบัน: <span className="text-blue-400 font-bold">${(stock.settledDividendNet ?? stock.manualDividend ?? stock.profitIncome ?? 0).toLocaleString()}</span></div>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-300 mb-1">ยอดเงินปันผลใหม่ที่ต้องการตั้ง (USD)</label>
            <input
              type="number"
              step="any"
              value={newDividend}
              onChange={(e) => setNewDividend(e.target.value)}
              className="w-full px-4 py-2.5 bg-gray-900 border border-gray-700 rounded-lg text-white focus:outline-none focus:border-blue-400"
              placeholder="ตัวอย่าง: 100"
              required
            />
          </div>

          <div className="flex justify-end gap-3 mt-2">
            <button type="button" onClick={onClose} disabled={isLoading} className="px-4 py-2 text-sm font-bold text-gray-400 hover:text-white transition-colors">ยกเลิก</button>
            <button type="submit" disabled={isLoading} className="px-4 py-2 text-sm font-bold text-black bg-blue-400 hover:bg-blue-500 rounded-lg transition-transform active:scale-95 disabled:opacity-50">
              {isLoading ? 'กำลังบันทึก...' : 'บันทึกเงินปันผล'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditDividendModal;